module.exports = __webpack_public_path__ + "img/pchomeadon.ea48a6aa.svg";